export class IntDate {

    private _date: number;

    public constructor(intDate: number) {
        this._date = intDate;
    }

    public get year(): number {
        return (this._date / 10000) | 0;
    }

    public get month(): number {
        var res = this._date;
        res = (res - (this.year * 10000)) | 0
        return (res / 100) | 0;
    }

    public get day(): number {
        return this._date % 100;
    }

    public get date(): number {
        return this._date;
    }

    public toString() {
        return "" + this.year + "-" + (this.month < 10 ? "0" : "") + this.month + "-" + (this.day < 10 ? "0" : "") + this.day;
    }

}